import { CompilationPlayerTrack, RadioStationTrack, StreamingPlayerImage, StreamingPlayerStylesImageFitValues, StreamingPlayerStylesImagePositionValues } from '@heardis/stream-contracts';
import { useEffect, useState } from 'react';
import { getArtworkUri } from '../../../utils/artwork';
import { Logger } from '../../../utils/logger';
import { classNames } from '../../../utils/styles';
import Image from '../Image';
import classes from './Artwork.module.css';

const logger = new Logger('artwork');

type ArtworkProps = {
  defaultArtwork: StreamingPlayerImage;
  alwaysDefaultEnabled: boolean;
  track?: RadioStationTrack | CompilationPlayerTrack;
};

function Artwork({ defaultArtwork, alwaysDefaultEnabled, track }: ArtworkProps): JSX.Element {
  const [url, setUrl] = useState<string>('');
  const isDefaultArtwork = url === defaultArtwork.url;
  /** @TOASK These changes reflect the contracts, but not the ui. How should we handle it? */
  const blur = isDefaultArtwork ? defaultArtwork.blur : '0px';
  const position = isDefaultArtwork ? defaultArtwork.position : StreamingPlayerStylesImagePositionValues.CENTER;
  const fit = isDefaultArtwork ? defaultArtwork.fit : StreamingPlayerStylesImageFitValues.COVER;

  useEffect(() => {
    setUrl(getArtworkUri(defaultArtwork.url, track?.artworkUri, alwaysDefaultEnabled));
  }, [defaultArtwork.url, alwaysDefaultEnabled, track?.artworkUri]);

  const handleArtworkError = (): void => {
    logger.warn(`error loading artwork with url: "${url}" from track:`, track);
    setUrl(defaultArtwork.url);
  };

  return (
    <picture className={classNames(classes.picture, classes.roundedBorder)}>
      <Image url={url} alt={track?.title || 'Artwork placeholder'} blur={blur} position={position} fit={fit} onError={handleArtworkError} width="100%" height="100%" />
    </picture>
  );
}

export default Artwork;
